module.exports = __webpack_public_path__ + "img/renta4.7b813915.png";